export default __webpack_public_path__ + "static/media/work__card-icon-1.bb64957c.svg";